<template>
  <div>
    <v-row class="mt-4 px-4">
      <v-col :cols="isMobile ? 12 : 3">
        <vAlertHeader
          title="1. Select Activity"
          :color="getThemeColor"
        ></vAlertHeader>
        <v-select
          v-model="selectedActivityID"
          :items="activities"
          label="Select Activity to Edit"
          @change="loadSelectedActivity"
          class="mb-4"
        />

        <vAlertHeader
          :title="!form.id ? 'Create Activity' : 'Edit Activity'"
          :color="getThemeColor"
        ></vAlertHeader>
        <div v-if="isAdmin && form">
          <v-form ref="appForm" @submit.prevent="handleSubmit">
            <v-select
            v-if="!form.id"
              v-model="form.clientIDs"
              multiple
              :items="clients"
              :label="'Select '+getCompanyLabels.client"
              required
            />
            <v-text-field
            v-if="!form.id"
              v-model="form.title"
              label="Activity Title / Reference"
              required
            />
            <v-card-title v-else style="color: blue;">
              {{ form.name }} | {{ form.reference }} —
                      <strong>Status:</strong> {{ form.status }}
            </v-card-title>
            <div v-if="!form.id">
            <v-select
              v-model="form.staffID"
              :items="staff"
              label="Staff In Charge"
          
            />

            <Datetime
              v-model="form.start"
              label="Estimated Start Date & Time"
              format="YYYY-MM-DD H:i:s"
            ></Datetime>

            <Datetime
              v-model="form.end"
              label="Estimated Due Date & Time"
              format="YYYY-MM-DD H:i:s"
            ></Datetime>

            <v-select
              :readonly="!isAdmin"
              v-model="form.rateID"
              :items="rates"
              label="Select Rate"
            />

            <v-text-field
              :readonly="!isAdmin"
              label="Hours Per Each Day"
              v-model="form.hours"
            ></v-text-field>
          </div>
          <div :class="isMobile ? 'mx-4':''">
            <v-select
              v-model="form.statusID"
              :items="activityStages"
              :label="form.id ? 'Update Status': 'Activity Status'"
              required
              @input="openUpdateActivityStatus"
            />

            <v-btn color="primary" @click="handleSubmit">
              {{ form.id ? "Update" : "Create" }} Activity
            </v-btn></div>
          </v-form>

          <CrudDatabase
      v-if="isAdmin && tables.length > 0"
      :tables="tables"
      :currentCompany="getUserCompany"
      :single="true"
    ></CrudDatabase>
        </div>
      </v-col>
      <v-col :cols="isMobile ? 12 : 9">
        <v-card class="pa-4" elevation="2">
          <v-card-title>
            <span class="headline">Activity Tracker</span>
          </v-card-title>

          <!-- Admin Form -->

          <!-- Client View / Admin Preview -->
          <v-card-text>
            <v-expand-transition>
              <v-alert type="info" outlined v-if="activities.length < 1"> No Activities Available. </v-alert>
            </v-expand-transition>

           
              <v-expansion-panels>
                <v-expansion-panel
                  v-for="(activity, index) in activities"
                  :key="activity.id"
                >
                  <v-expansion-panel-header>
                    <div>
                      <strong>Activity ID: </strong> {{ activity.name }} | {{ activity.reference }} —
                      <strong>Status:</strong> {{ activity.status }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-timeline dense>
                      <v-timeline-item
                        v-for="(stage, sIndex) in activityStages"
                        :key="sIndex"
                        :color="getTimelineColor(activity.status, stage)"
                        small
                      >
                        <v-card class="pa-3" outlined>
                          <div class="font-weight-bold">{{ stage.name }}</div>
                          <div
                            v-if="activity.status === stage"
                            class="text-caption grey--text"
                          >
                            <div>
                              <strong>{{ getCompanyLabels.client }}:</strong> {{ activity.name }}
                            </div>
                            <div>
                              <strong>{{}} Reference:</strong>
                              {{ activity.reference }}
                            </div>
                            <div>
                              <strong>{{}} Institution:</strong> {{ activity.institution }}
                            </div>
                            <!-- <div>
                              <strong>Updated:</strong>
                              {{ formatDate(activity.updatedAt) }}
                            </div> -->
                          </div>
                        </v-card>
                      </v-timeline-item>
                    </v-timeline>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
           
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <GlobalDialogSlot title="Confirm Status Update" @close-dialog="closeDialog()" :dialog="dialog">
      <v-btn @click="handleSubmit()" color="green" dark class="mx-8 my-8" v-if="selectedStatus">
        Update Status To {{ selectedStatus.name }}
      </v-btn>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import clientsJs from "@/plugins/clients";
import helpersJs from "@/plugins/helpers";
import staffJs from "@/plugins/staff"
import tasksJs from "@/plugins/tasks";
import vAlertHeader from "@/components/Legos/vAlertHeader";
import Datetime from "@/components/myLibrary/DateTimePicker.vue";
import moment from "moment"
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue"
import CrudDatabase from "baron-vue-crud-databases";


export default {
  name:"ActivityTracker",
  components: { vAlertHeader,Datetime,GlobalDialogSlot ,CrudDatabase},
  data:() =>({
    dialog:false,updateStatus:false,
    tables:[{
      name:'tasks_status',
      industry:'All',
      fk:null,
      ft:null,
      alevel:7
    }],
      clients: [],
      staff:[],
      activityStages: [],
      activities: [],
      rates:[],
      form: {},
      selectedActivityID: null,
      selectedStatus:null
    }),
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getRetrieveAllRatesRoute() {
      return this.$store.getters.getRetrieveAllRatesRoute;
    },
  },
  
  async mounted() {
    this.initialiseForm()
    await this.getAllTasks()
    await this.getAllTasksStatuses();
    await this.getAllClients();
    await this.getAllRates()
    await this.getAllStaff()
  },
  methods: {
    initialiseForm(){
      const date = moment()
      this.selectedActivityID = null;
      this.form = {
        id: null,
        clientIDs: [],
        title: null,
        statusID: null,
        start: date.format("YYYY-MM-DD HH:mm:ss"),
        end: date.add(14, "days").format("YYYY-MM-DD HH:mm:ss"),
        staffID: null,
        rateID: null,
        rates: 0,
        hours: 1,
        caseID: null,
      }
    },
    async getAllTasks(){
      const activities = await tasksJs.getAllTasks()
      this.formatAndSetActivities(activities)
    },
    formatAndSetActivities(activities){
      if(activities.length > 0){
        this.activities = []
        activities.forEach(activity => {
          this.activities.push({...activity,
            text: `${activity.title} | ${activity.name} | ${activity.reference}`,
            value:activity.id
          })
        })
      }
    },
    async getAllClients() {
      this.$store.commit('setLoader',true)
      const clients = await clientsJs.getAllClients();
      this.$store.commit('setLoader',false)
      if (clients.length > 0) {
        this.clients = [];
        clients.forEach((client) => {
          this.clients.push({
            text: `${client.name} | ${client.institution}`,
            value: client.id,
          });
        });
      }
    },
    async getAllTasksStatuses() {
      this.$store.commit("setLoader", true);
      const activityStages = await tasksJs.getAllTasksStatuses();
      if (activityStages.length > 0) {
        this.activityStages = [];
        activityStages.forEach((activityStage) => {
          this.activityStages.push({...activityStage,
            text: activityStage.name,
            value: activityStage.id,
          });
        });
      }
      this.$store.commit("setLoader", false);
    },
    getTimelineColor(currentStatus, stage) {
      const currentStageIndex = this.activityStages.findIndex(stage => {
        return stage.name == currentStatus
      });

      const stageIndex = this.activityStages.findIndex(stg => {
        return stg.id == stage.id
      })
      return stageIndex <= currentStageIndex ? "green" : "grey";
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
    openUpdateActivityStatus(){
      if(this.form.id){
        this.selectedStatus = this.activityStages.find(stage =>{
        return stage.id == this.form.statusID
      }) 
        this.dialog = true
      }
      
    },
    async handleSubmit() {
      if (
        this.form.clientIDs.length < 1 ||
        !this.form.title ||
        !this.form.statusID 
      ) {
        return alert("Client(s), Title & Status are All Required!.");
      }
      this.$store.commit('setLoader',true)
      const activities = await tasksJs.saveOrEditTasks(
          this.form.clientIDs,
          this.form.title,
          this.form.statusID,
          null,
          this.form.id,
          this.form.start,
          this.form.end,
          this.form.staffID,
          this.form.rateID,
          this.form.rates,
          this.form.hours,
          this.form.caseID
        )
       
       
        this.$store.commit('setLoader',false)
        if(activities.length > 0){
          this.formatAndSetActivities(activities)
          if (this.form.id) {
        this.$toast.success("Activity Updated!",{duration:3000});
      } else {
        this.$toast.success("Activity Created!",{duration:3000});
      }
        }
        
      this.initialiseForm();
      this.closeDialog()
    },
    loadSelectedActivity() {
      const activity = this.activities.find((a) => a.id === this.selectedActivityID);
      
      if (activity) {
        this.form = { ...activity,
          clientIDs:[activity.client_id],staffID:activity.staff_id,
          statusID:activity.status_id,rateID:activity.rate_id };
      }
      
    },
    async getAllStaff(){
      this.$store.commit('setLoader',true)
      const staff = await staffJs.getAllStaff()
      this.$store.commit('setLoader',false)
      if(staff.length > 0){
        this.staff = []
        staff.forEach(staf => {
          this.staff.push({
          text:`${staf.name} | ${staf.id_number}`,
          value:staf.id,
          id:staf.id,
          idNumber:staf.id_number})
        })
      }
    },
    async getAllRates() {
      this.$store.commit('setLoader',true)
      const rates = await helpersJs.getAllRates(
        this.getApiUrl + this.getRetrieveAllRatesRoute
      );
      this.$store.commit('setLoader',false)
      if (rates.length > 0) {
        this.rates = [];
        rates.forEach((rate) => {
          this.rates.push({
            text: `${rate.name} [${this.getCurrency}${rate.price}]`,
            value: rate.id,
            id: rate.id,
            name: rate.name,
          });
        });
        this.rates.unshift({
          text: `Free Service [${this.getCurrency} 0]`,
          value: 0,
          id: 0,
          name: "Not Rated Booking",
        });
      }
    },
    closeDialog(){
      this.dialog=false
      this.updateStatus=false
    }
  },
};
</script>

<style scoped>
.v-timeline {
  max-height: 400px;
  overflow-y: auto;
}
</style>
